/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <footer>
    {/* Footer Start */}
    <div className="container-fluid footer text-white py-5">
      <div className="container">
        <div className="row g-4">
          {/* Left Column - About */}
          <div className="col-md-6 col-lg-5">
            <h3 className="text-white">
              <i className="fa fa-map me-2"></i> CGIS Qatar
            </h3>
            <p  className="col-md-8" >
              Part of the Ministry of Municipality, CGIS is the
              official geospatial agency in the State of Qatar
            </p>
            {/* Social Icons */}
            <div className="d-flex">
              <a
                className="btn btn-md-square rounded-circle   text-white me-2"
                href="https://www.facebook.com/p/The-Centre-for-GIS-Ministry-of-Municipality-100064823825358/?paipv=0&eav=AfavVFlCWx2aRExUPHEFIIBwr8qe-gba_h6VeISeVrF8-c0GVTQJfjUWscHpBtmthe8&_rdr"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                className="btn btn-md-square rounded-circle   text-white me-2"
                href="https://x.com/albaladiya/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                className="btn btn-md-square rounded-circle   text-white me-2"
                href="https://www.instagram.com/albaladiya/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                className="btn btn-md-square rounded-circle   text-white me-2"
                href="https://www.linkedin.com/company/the-centre-for-gis-state-of-qatar/people/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a
                className="btn btn-md-square rounded-circle   text-white me-2"
                href="https://www.youtube.com/@masouns"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>

          {/* Middle Column - Useful Links */}
          <div className="col-md-6 col-lg-3">
            <h4 className="text-white">Useful Links</h4>
            <ul className="list-unstyled footer-item text-white">
              <li >
              <NavLink to="/en/about" >
                  <i className="fas fa-angle-right me-2"></i> About Us
                </NavLink>
              </li>
              <li >
              <NavLink to="/en/projects" >
                  <i className="fas fa-angle-right me-2"></i> Projects
                </NavLink>
              </li>
              <li >
                <NavLink to="/en/services" >
                  <i className="fas fa-angle-right me-2"></i> Services
                </NavLink>
              </li>
              <li >
                <NavLink to="/en/products" >
                  <i className="fas fa-angle-right me-2"></i> Products
                </NavLink>
              </li>
              <li >
                <NavLink to="/en/training" >
                  <i className="fas fa-angle-right me-2"></i> Training
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Right Column - Contact Info */}
          <div className="col-md-12 col-lg-4">
            <h4 className="text-white">Contact Us</h4>
            <div className="d-flex align-items-center mb-3">
              <div className="  text-white rounded-circle p-3 me-3">
                <i className="fas fa-map-marker-alt fa-lg"></i>
              </div>
              <div>
                <h5 className="text-white mb-1">Address</h5>
                <p className="mb-0">P.O. Box 22088, Qatar</p>
              </div>
            </div>

            <div className="d-flex align-items-center mb-3">
              <div className="  text-white rounded-circle p-3 me-3">
                <i className="fas fa-envelope fa-lg"></i>
              </div>
              <div>
                <h5 className="text-white mb-1">Mail Us</h5>
                <p className="mb-0">info@gisqatar.org.qa</p>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <div className="  text-white rounded-circle p-3 me-3">
                <i className="fas fa-phone-alt fa-lg"></i>
              </div>
              <div>
                <h5 className="text-white mb-1">Telephone</h5>
                <p className="mb-0">(+974) 44266284</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Copyright Section */}
    <div className="container-fluid   text-center py-3">
      <p className="mb-0 small">&copy; 2024 GIS Qatar All Rights Reserved.</p>
    </div>

    {/* Back to Top Button */}
    <a
      className="btn btn-primary btn-lg-square rounded-circle back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
    >
      <i className="fa fa-arrow-up" style={{ padding: "9px" }}></i>
    </a>
  </footer>
  );
};

export default Footer;
